import { render, staticRenderFns } from "./business.vue?vue&type=template&id=67feceb9&scoped=true&"
var script = {}
import style0 from "./business.vue?vue&type=style&index=0&id=67feceb9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67feceb9",
  null
  
)

export default component.exports